import React, { useState, useEffect } from 'react';
import AOS from 'aos'; // AOS for scroll animations
import 'aos/dist/aos.css'; // AOS styles
import Footer from '../components/Footer';
import Header from '../components/Header';
import Loader from '../components/Loader';  // Import the loader component

const fetchServiceData = async () => {
  const localImages = [
    '/3.jpg',
    '/4.jpg',
    '/5.jpg',
    '/6.jpg',
    '/pexels-500photos-com-15338-93400.jpg',
    '/pexels-asphotograpy-224924.jpg',
    '/pexels-daniel-12255.jpg',
    '/pexels-davidmcbee-392031.jpg',
    '/pexels-pixabay-162639.jpg',
    '/pexels-pixabay-236698.jpg',
    '/pexels-rezwan-1078884.jpg',
    '/pexels-rezwan-1116035.jpg',
    '/pexels-yury-kim-181374-585419.jpg',
    '/pexels-ywanphoto-188679.jpg',
  ];

  const getRandomImage = () => localImages[Math.floor(Math.random() * localImages.length)];

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve([
        {
          id: 1,
          image: getRandomImage(),
          name: 'Building Construction',
          description: 'We provide top-notch residential and commercial construction services with precision and quality.',
          stats: { projectsCompleted: 250, clientSatisfaction: 95, workforce: 1200 }
        },
        {
          id: 2,
          image: getRandomImage(),
          name: 'Road Construction',
          description: 'Specializing in durable and sustainable road networks for seamless transportation.',
          stats: { projectsCompleted: 180, clientSatisfaction: 90, workforce: 800 }
        },
        {
          id: 3,
          image: getRandomImage(),
          name: 'Bridge & Tunnel Engineering',
          description: 'Expert solutions for bridges and tunnels, ensuring safety and durability.',
          stats: { projectsCompleted: 75, clientSatisfaction: 92, workforce: 500 }
        },
        {
          id: 4,
          image: getRandomImage(),
          name: 'Steel & Concrete Structures',
          description: 'High-quality steel and concrete solutions for large-scale infrastructure projects.',
          stats: { projectsCompleted: 90, clientSatisfaction: 97, workforce: 600 }
        },
      ]);
    }, 2000);
  });
};





const Services = () => {
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    const getServiceData = async () => {
      setIsLoading(true);
      const data = await fetchServiceData();
      setServices(data);
      setIsLoading(false);
    };

    getServiceData();
  }, []);

  return (
    <>
      <Header />
      <br /><br /><br /><br />

      <section className="bg-gradient-to-r from-gray-700 to-[#29313F]  text-white py-16">
        <div className="container mx-auto text-center px-6">
          <h2 className="text-3xl sm:text-4xl font-semibold mb-8" data-aos="fade-up">Our Construction Services</h2>
          {isLoading ? (
            <Loader />
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12">
              {services.map((service) => (
                <div key={service.id} className="flex flex-col items-center text-center p-6 bg-white rounded-lg shadow-lg hover:scale-105 transform transition-all">
                  <img
                    src={service.image}
                    onError={(e) => (e.target.src = 'https://via.placeholder.com/600x400?text=Image+Not+Available')}
                    alt={service.name}
                    className="w-full h-56 object-cover rounded-lg mb-4"
                  />
                  <h3 className="text-2xl font-semibold text-gray-800">{service.name}</h3>
                  <p className="text-gray-700 mt-2">{service.description}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="py-16 bg-gray-100">
        <div className="container mx-auto text-center px-6">
          <h2 className="text-3xl sm:text-4xl font-semibold text-gray-900 mb-8" data-aos="fade-up">Project Achievements</h2>
          {isLoading ? (
            <Loader />
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-12">
              {services.map((service) => (
                <div key={service.id} className="bg-white p-6 rounded-lg shadow-lg hover:scale-105 transition-transform hover:shadow-xl">
                  <h3 className="text-xl font-semibold mb-4">{service.name}</h3>
                  <div className="space-y-4">
                    <div className="flex justify-between">
                      <span className="font-medium">Projects Completed:</span>
                      <span className="text-gray-600">{service.stats.projectsCompleted}+</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-medium">Client Satisfaction:</span>
                      <span className="text-gray-600">{service.stats.clientSatisfaction}%</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="font-medium">Workforce:</span>
                      <span className="text-gray-600">{service.stats.workforce}+</span>
                    </div>
                  </div>
                  <div className="mt-4">
                    <div className="flex items-center justify-between">
                      <span className="text-sm font-medium">Client Satisfaction</span>
                      <span className="text-sm font-semibold">{service.stats.clientSatisfaction}%</span>
                    </div>
                    <div className="w-full bg-gray-200 h-2 mt-2 rounded-full">
                      <div className="bg-[#29313F]  h-2 rounded-full" style={{ width: `${service.stats.clientSatisfaction}%` }}></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Services;
